import styled from 'styled-components';

export const NotificationWrapper = styled.div`
  > div {
    margin-bottom: ${({ theme }) => theme.spacing[8]};
  }
`;
